<template>
  <div class="note-box" :class="{ showPopup: isShow }">
    <a-spin wrapperClassName="list-spin" tip="加载中..." :spinning="loading">
      <div class="note-top">
        <div class="top-title">笔记</div>
        <div>
          <a-tooltip title="新增笔记">
            <svg class="icon-svg" @click="updateNote(null)" v-show="viewType == 'person'">
              <use xlink:href="#icon-add-note" />
            </svg>
          </a-tooltip>
          <a-tooltip title="查看共享笔记">
            <svg class="icon-svg" @click="viewType = 'all'" v-show="viewType == 'person'">
              <use xlink:href="#icon-view" />
            </svg>
          </a-tooltip>
          <a-tooltip title="返回我的笔记">
            <svg class="icon-svg" @click="viewType = 'person'" v-show="viewType == 'all'">
              <use xlink:href="#icon-return" />
            </svg>
          </a-tooltip>
          <a-tooltip title="关闭">
            <svg class="icon-svg icon-close" @click="close()">
              <use xlink:href="#icon-close" />
            </svg>
          </a-tooltip>
        </div>
      </div>
      <div class="int-list" v-show="!loading">
        <div class="int-item" v-for="(int, i) in intList"
          v-show="(viewType == 'all' && int.note.length) || (viewType == 'person' && int.mynote.length)">
          <div class="int-title" @click="switchChapter(i)">{{ int.InductionName }}</div>
          <template v-if="viewType == 'all'">
            <div class="note-item-box" v-for="note in int.note">
              <div class="user-box">
                <i class="user-head" :style="{ backgroundImage: 'url(' + note?.headPhotoPath + ')' }"></i>
                <span class="user-name">{{ note.userName }}</span>
              </div>
              <div class="note-item" @click="chooseNote(note)">
                <i class="note-mark" :style="{ background: note.themeColor }"></i>
                <div class="note-text" :style="{ background: note.bakColor }" v-if="note.text">{{ note.text }}</div>
                <div class="note-content">{{ note.content }}</div>
              </div>
            </div>
          </template>
          <template v-if="viewType == 'person'">
            <div class="note-item-box" v-for="note in int.mynote">
              <div class="note-item" @click="chooseNote(note)">
                <i class="note-mark" :style="{ background: note.themeColor }"></i>
                <div class="note-text" :style="{ background: note.bakColor }" v-if="note.text">{{ note.text }}</div>
                <div class="note-content">{{ note.content }}</div>
              </div>
            </div>
          </template>
        </div>
        <a-empty
          v-if="!loading && ((mynoteList.length == 0 && viewType == 'person') || (noteList.length == 0 && viewType == 'all'))"
          description="还没有任何笔记" />
      </div>
    </a-spin>
    <addNote :newNoteId="newNoteId" :userNote="userNote" @deleteNote="deleteNote()" @refreshList="refreshList($event)"
      @closeUpdate="closeUpdate()" v-if="userNote"></addNote>
  </div>
</template>
<script>
import addNote from './add-note/add-note.vue';
import UUID from 'uuid';

export default {
  name: 'note-box',
  components: {
    addNote
  },
  props: {
    chapter_num: Number,
    allNote: Array,
    noteData: Array
  },
  data() {
    return {
      userId: '',
      classId: '',
      fk_unitId: '',

      viewType: 'person',

      userNote: null,
      newNoteId: null,

      intList: [],
      noteList: [],
      mynoteList: [],

      isShow: false,
      loading: true,
      isNewTextbook: false
    }
  },
  mounted() {
    let { intList, userInfo, currentClass } = this.$store.state;
    this.intList = intList;
    this.userInfo = userInfo;
    this.userId = userInfo.PK_UserGuid;
    this.classId = currentClass.PK_ClassGuid;
    this.isNewTextbook = currentClass.IsNewTextbook;

    let chapter_num = this.chapter_num || 0;
    this.fk_unitId = this.intList[chapter_num].PK_InductionGuid;

    this.noteList = JSON.parse(JSON.stringify(this.noteData));
    this.mynoteList = this.noteList.filter(item => item.fk_studentId == this.userId);

    this.matchIntList();

    this.$store.subscribe((res) => {
      if (!res) return;
      let { type, payload } = res;

      if (type == "pilotNavOpen") this.isShow = payload === 'note';
    })
  },
  watch: {
    noteData: {
      handler(val) {
        this.noteList = JSON.parse(JSON.stringify(val));
        this.matchIntList();
      },
      deep: true
    },
    chapter_num(val) {
      this.fk_unitId = this.intList[val].PK_InductionGuid;
    }
  },
  methods: {
    //选择note
    chooseNote(note) {
      if (this.isNewTextbook) {
        this.$emit('chooseNote', note);
      }
      else {
        let id = note.fk_trainId;
        if (id) this.$emit('chooseCode', id);
      }

      if (this.viewType == 'person' && note.fk_unitId) {
        this.fk_unitId = note.fk_unitId;
        this.updateNote(note.uid);
      }
    },

    //匹配int
    matchIntList() {
      let userId = this.userId;
      let intList = this.intList;
      let noteList = this.noteList;

      intList.forEach(int => {
        let note = [];
        let mynote = [];
        note = noteList.filter(item => item.fk_unitId == int.PK_InductionGuid && item.public)
        mynote = noteList.filter(item => item.fk_unitId == int.PK_InductionGuid && item.fk_studentId == userId)

        if (this.isNewTextbook) {
          let note_code = noteList.filter(item => item.fk_trainId == int.PK_InductionGuid && item.public);
          let mynote_code = noteList.filter(item => item.fk_trainId == int.PK_InductionGuid && item.fk_studentId == userId);
          if (note_code) note = note.concat(note_code);
          if (mynote_code) mynote = mynote.concat(mynote_code);
        }
        else {
          int.children.forEach(citem => {
            citem.data.forEach(code => {
              let note_code = noteList.filter(item => item.fk_trainId == code.Guid && item.public);
              let mynote_code = noteList.filter(item => item.fk_trainId == code.Guid && item.fk_studentId == userId);

              if (note_code) note = note.concat(note_code);
              if (mynote_code) mynote = mynote.concat(mynote_code);
            })
          })
        }

        int.note = note || [];
        int.mynote = mynote || [];
      })
      this.intList = intList;

      this.loading = false;
    },
    //选择章节
    switchChapter(i) {
      this.$emit('switchChapter', i);
    },
    //更新note
    updateNote(uid) {
      if (this.userNote) return this.userNote = null;

      let userNote;

      if (uid == null) {
        uid = UUID.v1();
        let newNote = {
          uid,
          public: true,
          type: "unit",
          content: null,
          updateTime: this.$moment().format('YYYY-MM-DD HH:mm:ss').toString(),
        }

        userNote = this.allNote.find(item => item.fk_studentId == this.userId && item.fk_unitId == this.fk_unitId);

        if (userNote) userNote.notes.push(newNote);
        else {
          userNote = {
            fk_classId: this.classId,
            fk_studentId: this.userId,
            fk_unitId: this.fk_unitId,
            fk_trainId: '',
            notes: [newNote]
          }
        }
      }
      else userNote = this.allNote.find(item => item.fk_studentId == this.userId && item.fk_unitId == this.fk_unitId);

      this.userNote = userNote;
      this.newNoteId = uid;
    },
    //更新列表
    refreshList(note) {
      let noteList = this.noteList;
      let oldnote = noteList.find(item => note.uid == item.uid);
      if (oldnote) {
        noteList.forEach(item => {
          if (item.uid == note.uid) {
            item.content = note.content;
            item.public = note.public;
          }
        })
      }
      else {
        let item = this.userNote;
        noteList.push({
          fk_studentId: item.fk_studentId,
          fk_trainId: item.fk_trainId,
          fk_unitId: item.fk_unitId,
          ...note
        })
      }
      this.noteList = noteList;
      this.matchIntList();
    },
    //删除note
    deleteNote() {
      this.noteList = this.noteList.filter(item => item.uid != this.newNoteId);
      this.matchIntList();
      this.closeUpdate();
    },
    //折叠
    close() {
      this.$store.commit('pilotNavOpen', false);
      this.closeUpdate();
    },
    //关闭修改框
    closeUpdate() {
      this.userNote = null;
      this.newNoteId = null;
    },
  }
}


</script>

<style scoped lang="scss">
@import "./note-box.scss";
</style>